export default __webpack_public_path__ + "static/images/0.a0be926a.png";